<template>
   <BreadCrumb PageTitle=" Liste des types d'emplacement" />
    <ListeTypeEmplacement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
import ListeTypeEmplacement from "@/components/TypeEmplacement/ListeTypeEmplacement.vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";


  
    export default defineComponent({
      name: "ListeTypeEmplacementPage",
      components: {
        ListeTypeEmplacement,
      },
    });
  </script>